import classes from "./Footer.module.css";
import { email } from "../../util/config";

export default function Footer() {
  return (
    <footer className={classes.footer}>
      <p>Contact us at {email}</p>
      <p>Copyright all rights reserved @skyheight 2025</p>
    </footer>
  );
}
